import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import {
    Typography,
    Button,
    CssBaseline,
    Grid,
    Container,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Box
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getSignedUserData, patchCompany } from "../../store/actions/user/user_action";
import { useSnackbar } from "notistack";
import { connect, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(4),
        textAlign: "center",
        "& > p": {
            color: "#bf1650",
            "&::before": {
                display: "inline",
                content: '"⚠ "'
            }
        }
    },
    submit: {
        margin: theme.spacing(4, 0, 2)
    },
    link: {
        color: "#64b5f6",
        "&:hover": {
            color: "#53a3df"
        }
    }
}));

const options = [
    { value: 0, label: "Bez slike" },
    { value: 1, label: "", imgSrc: "/images/anima_memorandum_1.jpg" },
    { value: 2, label: "", imgSrc: "/images/anima_memorandum_2.jpg" }
];

// eslint-disable-next-line react/prop-types
const RadioWithImage = ({ value, label, imgSrc, onChange, checked }) => (
    <FormControlLabel
        value={String(value)}
        control={<Radio checked={checked} onChange={onChange} style={{ alignSelf: "flex-start" }} />}
        label={
            <div style={{ display: "flex", alignItems: "flex-start" }}>
                {imgSrc ? (
                    <img src={imgSrc} alt={label} style={{ width: 200, height: "auto", marginRight: 8, border: "dashed 1px #ccc" }} />
                ) : (
                    <Box style={{ width: 200, height: 282, marginRight: 8, border: "dashed 1px #ccc", background: "white" }}></Box>
                )}
                {/* <span>{label}</span> */}
            </div>
        }
    />
);

const Settings = (props) => {
    const { user } = props;
    const { company } = user;
    const dispatch = useDispatch();

    const { paper, form, submit } = useStyles();
    const [memorandum, setMemorandum] = useState(company?.memorandum || 0);
    const {
        handleSubmit,
        formState: { errors }
    } = useForm();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setMemorandum(company?.memorandum || 0);
    }, [company]);

    const handleRadioChange = (e) => {
        setMemorandum(parseInt(e.target.value, 10));
    };

    const onSubmit = async (data) => {
        data.memorandum = parseInt(memorandum);
        await patchCompany(company?.uuid, data)
            .then(() => {
                getSignedUserData(dispatch);
                return enqueueSnackbar("Uspešno ste sačuvali podešavanja", {
                    variant: "success"
                });
            })
            .catch((error) => {
                return enqueueSnackbar(error?.detail, {
                    variant: "warning"
                });
            });
    };

    return (
        <Container component="main" maxWidth="md">
            <CssBaseline />
            <Grid className={paper}>
                <Typography component="h1" variant="h5">
                    Podešavanja
                </Typography>
                <form onSubmit={handleSubmit(onSubmit)} className={form}>
                    <FormControl>
                        <FormLabel component="legend" style={{ marginBottom: "16px" }}>
                            Odaberite sliku za memorandum
                        </FormLabel>
                        <RadioGroup row value={memorandum} onChange={handleRadioChange}>
                            {options.map((option) => (
                                <RadioWithImage
                                    key={option.value}
                                    value={option.value}
                                    label={option.label}
                                    imgSrc={option.imgSrc}
                                    onChange={handleRadioChange}
                                    checked={memorandum === option.value}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                    <ErrorMessage errors={errors} name="memorandum" as="p" />

                    <Button type="submit" variant="contained" color="primary" className={submit}>
                        Sačuvajte podešavanja
                    </Button>
                </form>
            </Grid>
        </Container>
    );
};

Settings.propTypes = {
    user: PropTypes.object
};

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(Settings);
